import React from 'react';
import { IIconProps } from '../interfaces';

type Props = IIconProps & {
    size?: number | string; //  width/height
};

const StopAudioIcon: React.FC<Props> = ({
    color = '#ffffff',
    bgColor = '#3452FF',
    width,
    height,
    size = 44,
    classes,
    style,
}) => {
    const w = width ?? size;
    const h = height ?? size;

    return (
        <svg
            className={ classes ?? '' }
            style={ style ?? {} }
            width={ w }
            height={ h }
            viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#stopDropShadow)">
                <circle cx="22" cy="22" r="20" fill={bgColor} />
            </g>

            <rect
                x="15.625"
                y="15.625"
                width="12.75"
                height="12.75"
                fill={color}
                rx="1.5"
            />

            <defs>
                <filter id="stopDropShadow" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="0.86"/>
                    <feGaussianBlur stdDeviation="0.86"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
};

export default StopAudioIcon;
